import { render, staticRenderFns } from "./sensitivewordsinfolist.vue?vue&type=template&id=37a60756&scoped=true"
import script from "./sensitivewordsinfolist.vue?vue&type=script&lang=js"
export * from "./sensitivewordsinfolist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a60756",
  null
  
)

export default component.exports